<template>
    <div>
        <snoop-button
            theme="link"
            class="snoop-modal__close-icon"
            :aria-label="translations.closeButton"
            @click="$emit('close', $event)"
        >
            <snoop-icon name="close" hidden />
        </snoop-button>
        <snoop-html-content tag="h2" class="snoop-modal__title" :html="translations.headline" />

        <snoop-button theme="link" class="snoop-glossary__back-button" @click="$emit('close', $event)">
            <snoop-icon name="pointer" class="snoop-glossary__icon" rotate="270" />
            {{ translations.backButton }}
        </snoop-button>

        <ol type="1" class="snoop-glossary__list">
            <li
                v-for="(definition, index) in translations.definitions"
                :id="`js-snoop-glossary-${definition.id}`"
                :key="index"
                class="snoop-glossary__list-item"
            >
                <span class="snoop-glossary__list-label">{{ definition.label }}: </span><snoop-html-content tag="span" :html="definition.value" />
            </li>
        </ol>

        <snoop-button theme="link" class="snoop-glossary__back-button" @click="$emit('close', $event)">
            <snoop-icon name="pointer" class="snoop-glossary__icon" rotate="270" />
            {{ translations.backButton }}
        </snoop-button>
    </div>
</template>


<script>
import SnoopButton from './Button.vue'
import SnoopHtmlContent from './HtmlContent.vue'
import SnoopIcon from './Icon.vue'


export default {
    components: { SnoopButton, SnoopHtmlContent, SnoopIcon },

    props: {
        translations: { type: Object, required: true },
        termId: { type: String, default: '' },
    },

    mounted () {
        if (this.termId) {
            document.getElementById(`js-snoop-glossary-${this.termId}`).scrollIntoView({ behavior: 'smooth' })
        }
    },
}
</script>
